<script>
export default {
    name: "CallbackErrorMessage",
    props: {
        error: {
            required: true,
        },
        errorMsg: {
            required: true,
            type: String,
        }
    },
}
</script>

<template>
    <div v-if="error && error[errorMsg]"
         class="text-xs text-red-500 font-medium ps-5 mt-1 text-start"
         v-text="error[errorMsg][0]">
    </div>
</template>

<style scoped lang="scss">

</style>
